import { RolService } from './../../core/services/rol.service';
import { UserService } from './../../core/services/user.service';
import { User } from './../../core/models/user.model';
import { Component, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { Location } from '@angular/common';
import { A3LCompanyService } from '../../core/services/a3LCompany.service';
import { SetPasswordModel } from '../../core/models/setPassword.model';
import { A3LCompany } from '../../core/models/a3Lcompany.model';
import { EditFormBase } from '../../core/helper/editFormBase';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { GestionEmpleadoService } from '../../core/services/gestionEmpleado.service';
import { Configuration } from '../../core/configuration/configuration';
@Component({
  selector: 'app-usuario-detail',
  templateUrl: './usuario-detail.component.html',
  styleUrls: ['./usuario-detail.component.scss'],
  providers: [UserService, RolService, GestionEmpleadoService]
})
export class UsuarioDetailComponent extends EditFormBase<User, string> implements OnInit, OnChanges {

  roles: string[];
  a3LCompanies: A3LCompany[];
  userA3LCompanies: number[];
  setPasswordModel: SetPasswordModel = {
    UserName: '',
    NewPassword: '',
    ConfirmPassword: ''
  };

  selectedCompanies: number[] = [];

  constructor(
    _route: ActivatedRoute,
    private _modelUserService: UserService,
    private _gestionEmpleadosService: GestionEmpleadoService,
    _messageDialog: MessageDialog,
    private _rolService: RolService,
    _router: Router,
    _location: Location,
    protected _session: SessionHelper,
  ) {
    super(_modelUserService, _messageDialog, _route, _router, _location, User);
  }

  getModelInstance(): User {
    const user = new User();
    return user;
  }

  afterModelLoad(): void {
    // this.CargarEmpresasA3Laboral();
    this.CargarPermisosSobreEmpresas();
  }

  afterModelCreated(success: boolean): void {

  }

  afterModelUpdated(success: boolean): void {

  }

  ngOnInit() {
    this.getModel();
    this.CargarRoles();
  }

  CargarRoles() {
    this._rolService.getAllRoles().subscribe(res => {
      this.roles = res;
    });
  }

  CargarPermisosSobreEmpresas() {
    this._gestionEmpleadosService.getCompanyPermissionsByUserId(this.id).subscribe(
      response => {
        this.selectedCompanies = response || [];
      },
      error => {
        console.error(error);
      });
  }

  // CargarEmpresasA3Laboral(){

  //   this.userA3LCompanies = this.model.A3LCompanies.map(({ CompanyCode }) => CompanyCode);

  //   if(this.model.A3LCompanies){
  //     this._a3LCompanyService.getByIds(this.userA3LCompanies).subscribe(res => this.a3LCompanies = res,
  //       err => console.error(err))
  //   }
  // }

  onSubmitFormPassword(model: SetPasswordModel, isValid: boolean) {
    model.UserName = this.model.UserName;
    this._modelUserService.setPassword(model).subscribe(
      res =>
        this._messageDialog.ShowMessage(
          'Contraseña actualizada correctamente',
          'Actualizado'
        ),
      err => {
        console.error(err);
        this._messageDialog.ShowException(err.error_description);
      }
    );
  }

  onSubmitPermisosSobreEmpresas(isValid: boolean) {
    this._gestionEmpleadosService.setCompanyPermissions(this.id, this.selectedCompanies).subscribe(
      response => {
        this._messageDialog.ShowMessage(
          'Permisos sobre empresas actualizados correctamente',
          'Actualizado'
        )
      },
      error => {
        console.error(error);
        this._messageDialog.ShowException(error.error_description);
      }
    );
  }

  create() {
    this.model.UserName = this.model.Email;
    super.create();
    this.model.Id = this.id;
  }
  update() {
    // let index: number[] = new Array<number>();

    // this.model.A3LCompanies.forEach((element, i) => {
    //   const company = this.userA3LCompanies.find(x=> x === element.CompanyCode);
    //   if(!company){
    //     index.push(i);
    //   }
    // });

    // index.forEach(element => {
    //   this.model.A3LCompanies.splice(element, 1);
    // });
    this.model.UserName = this.model.Email;
   
    const hasAdminRole = this._session.User?.Roles?.includes(Configuration.rolAdministrador) || false;
    const isEditingSelf = this._session.UserId === this.model.Id;

    if (hasAdminRole && isEditingSelf && !this.model?.Roles?.includes(Configuration.rolAdministrador)) {
      console.error('Error: El usuario no tiene el rol de Admin');
      this._messageDialog.ShowAlert('No puedes eliminar tu propio rol de Admin', 'Error')
    } else {
      super.update();

    }
  }
}
